import React from "react";
import royal_jewel_map from "../images/projects/royal_jewel_map.png";
import royal_jewel_arch from "../images/projects/royal_jewel_arch.png";
import { useState } from "react";
import { Helmet } from "react-helmet";

const RoyalJewelPremium = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="bg-gray-950 text-white font-sans">
      <Helmet>
        <title>Royal Jewel | EstateGhar</title>
        <meta
          name="description"
          content="Royal Jewel - Luxury Residential Development in Islamabad"
        />
        <meta
          name="keywords"
          content="royal jewel, luxury residential, projects in islamabad, real estate, property requests, buy property, rent property, real estate agents, property listings, EstateGhar"
        />
          <link rel="canonical" href="https://estateghar.com/projects/royal-jewel" />
      </Helmet>
      {/* HERO */}
      {showModal && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
          <div className="bg-gray-900 max-w-6xl w-full max-h-[90vh] overflow-y-auto rounded-2xl p-6 relative">
            {/* Close */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-white text-xl"
            >
              ✕
            </button>

            <h2 className="text-2xl font-bold mb-6 text-center">
              Royal Jewel Payment Plan
            </h2>

            {/* TABLE COMPONENT */}
            <div className="space-y-10">
              {[
                {
                  title: "Lower Ground Shops",
                  data: [
                    ["156", "7,488,000", "1,872,000", "561,600"],
                    ["150", "7,200,000", "1,800,000", "540,000"],
                    ["282", "13,536,000", "3,384,000", "1,015,200"],
                    ["215", "10,320,000", "2,580,000", "774,000"],
                    ["190", "9,120,000", "2,280,000", "684,000"],
                  ],
                },
                {
                  title: "Ground Shops",
                  data: [
                    ["156", "9,048,000", "2,262,000", "678,600"],
                    ["150", "8,700,000", "2,175,000", "652,500"],
                    ["215", "12,470,000", "3,117,500", "935,250"],
                    ["190", "11,020,000", "2,755,000", "826,500"],
                  ],
                },
              ].map((section, i) => (
                <div key={i}>
                  <h3 className="text-lg font-semibold mb-3 text-yellow-400">
                    {section.title}
                  </h3>

                  <div className="overflow-x-auto">
                    <table className="w-full text-sm border border-gray-700">
                      <thead className="bg-gray-800">
                        <tr>
                          <th className="p-2">Size</th>
                          <th className="p-2">Total Price</th>
                          <th className="p-2">Down Payment</th>
                          <th className="p-2">Quarterly</th>
                        </tr>
                      </thead>
                      <tbody>
                        {section.data.map((row, idx) => (
                          <tr
                            key={idx}
                            className="text-center border-t border-gray-700"
                          >
                            {row.map((cell, c) => (
                              <td key={c} className="p-2">
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}

              <p className="text-sm text-gray-400 text-center">
                10% extra charges apply on corner units.
              </p>
            </div>
          </div>
        </div>
      )}
      <section
        className="h-screen bg-cover bg-center flex items-center justify-center text-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c')",
        }}
      >
        <div className="bg-black/60 p-10 rounded-2xl backdrop-blur-md">
          <h1 className="text-5xl font-bold tracking-wide">Royal Jewel</h1>
          <p className="mt-4 text-lg text-gray-300">
            Commercial & Residential Luxury Living
          </p>
          <div className="flex gap-4 justify-center mt-6 flex-wrap">
            {/* Book Now */}
            <a
              href="https://wa.me/923487172565?text=I'm%20interested%20in%20Royal%20Jewel%20Project,%20Can%20you%20tell%20me%20more?"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-400 transition"
            >
              Book Now
            </a>

            {/* Payment Plan */}
            <button
              onClick={() => setShowModal(true)}
              className="px-6 py-3 border border-white text-white rounded-lg hover:bg-white hover:text-black transition"
            >
              Payment Plan
            </button>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-20 px-6 max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
        <img
          src="https://images.unsplash.com/photo-1505691938895-1758d7feb511"
          className="rounded-2xl shadow-lg"
          alt=""
        />
        <div>
          <h2 className="text-3xl font-semibold mb-4">
            MARJAN Associates & Builders
          </h2>
          <p className="text-gray-300 leading-relaxed">
            We listen, understand, evaluate, and deliver excellence. Property is
            not a game — it's a serious investment backed by experience, trust,
            and commitment.
          </p>
        </div>
      </section>

      {/* ISLAMABAD */}
      <section className="py-20 bg-gray-900 text-center px-6">
        <h2 className="text-3xl font-semibold mb-6">
          Islamabad – The Prime Location
        </h2>
        <p className="max-w-3xl mx-auto text-gray-400">
          A perfectly planned capital city with lush green landscapes, offering
          a premium lifestyle and strategic importance.
        </p>

        <img
          src="https://images.unsplash.com/photo-1582719478250-c89cae4dc85b"
          className="mt-10 rounded-xl mx-auto shadow-lg"
          alt=""
        />
      </section>

      {/* FAISAL HILLS */}
      <section className="py-20 px-6 max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold mb-10 text-center">
          Faisal Hills
        </h2>

        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-gray-400 leading-relaxed">
              Located near B-17 Islamabad, Faisal Hills offers breathtaking
              views of Margalla Hills with modern infrastructure and peaceful
              surroundings.
            </p>

            {/* FEATURES */}
            <div className="grid grid-cols-2 gap-4 mt-6">
              {[
                "Electricity",
                "CCTV",
                "Gas & Water",
                "Parks",
                "Masjid",
                "Hospital",
                "Market",
                "Jogging Tracks",
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white/10 backdrop-blur-md p-3 rounded-lg text-center"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

          <img src={royal_jewel_map} className="rounded-2xl shadow-lg" alt="" />
        </div>
      </section>

      {/* AMENITIES */}
      <section className="py-20 bg-gray-900 px-6">
        <h2 className="text-3xl text-center font-semibold mb-12">
          Luxury Amenities
        </h2>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {[
            "24/7 Security",
            "Swimming Pool",
            "High-Speed Elevators",
            "Reception Lobby",
            "Super Store",
            "Solar System",
            "Fire Safety",
            "Marble Flooring",
            "Earthquake Resistant",
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white/10 backdrop-blur-md p-6 rounded-2xl text-center hover:scale-105 transition"
            >
              {item}
            </div>
          ))}
        </div>
      </section>

      {/* APARTMENTS */}
      <section className="py-20 px-6 max-w-6xl mx-auto">
        <h2 className="text-3xl text-center font-semibold mb-12">
          Apartment Options
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              title: "Studio",
              img: "https://images.unsplash.com/photo-1493809842364-78817add7ffb",
            },
            {
              title: "1 Bedroom",
              img: "https://images.unsplash.com/photo-1507089947368-19c1da9775ae",
            },
            {
              title: "2 Bedroom",
              img: "https://images.unsplash.com/photo-1505691723518-36a5ac3b2d8b",
            },
          ].map((apt, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden shadow-lg bg-gray-900"
            >
              <img src={apt.img} className="h-56 w-full object-cover" />
              <div className="p-5 text-center">
                <h3 className="text-xl font-semibold">{apt.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FLOOR PLANS */}
      <section className="py-20 bg-gray-900 px-6 text-center">
        <h2 className="text-3xl font-semibold mb-10">Floor Plans</h2>

        <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          <img
            src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d"
            className="rounded-xl shadow-lg"
          />
          <img
            src="https://images.unsplash.com/photo-1598928506311-c55ded91a20c"
            className="rounded-xl shadow-lg"
          />
        </div>
        <div className="grid md:grid-cols-1 gap-6 mt-10 max-w-6xl mx-auto">
          <img src={royal_jewel_arch} className="rounded-xl shadow-lg" />
        </div>
      </section>

      {/* COMMUNITY */}
      <section className="py-20 px-6 text-center max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold mb-6">Community Living</h2>
        <p className="text-gray-400">
          Royal Jewel offers more than just a home — it's a thriving community
          surrounded by prestigious developments.
        </p>
      </section>

      {/* CTA */}
      <section className="py-20 bg-yellow-500 flex items-center flex-col text-black text-center">
        <h2 className="text-3xl font-bold">Invest in Your Future Today</h2>
        <p className="mt-3">Limited units available</p>
        <a href="https://wa.me/923487172565?text=I'm%20interested%20in%20Royal%20Jewel%20Project,%20Can%20you%20tell%20me%20more?">
          <div
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 px-6 py-3 w-[300px] flex-center bg-black text-white font-semibold rounded-lg hover:bg-gray-400 transition"
          >
            Contact Now
          </div>
        </a>
      </section>

      {/* FOOTER */}
      <footer className="bg-black text-center py-6 text-gray-400">
        © Royal Jewel | Faisal Hills Islamabad
      </footer>
    </div>
  );
};

export default RoyalJewelPremium;
